import { Reveal } from "./motion";
import { Star } from "lucide-react";
import { REVIEWS } from "../data";

export default function Reviews() {
  return (
    <section id="reviews" data-testid="reviews" className="bg-[#030303] py-20 md:py-32">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <Reveal>
          <p className="text-xs tracking-[0.3em] uppercase text-[#FF3B30] mb-4">Word of mouth</p>
          <h2 className="font-display font-bold uppercase tracking-tight text-4xl md:text-6xl leading-none max-w-3xl">
            The reviews do the talking.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-zinc-800 border border-zinc-800">
          {REVIEWS.map((r, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08}>
              <div data-testid={`review-${i}`} className="bg-[#0A0A0A] p-8 h-full flex flex-col">
                <div className="flex gap-1 mb-4">
                  {Array.from({ length: r.rating }).map((_, s) => (
                    <Star key={s} size={15} className="fill-[#FF3B30] text-[#FF3B30]" />
                  ))}
                </div>
                <p className="text-zinc-200 leading-relaxed flex-1">“{r.text}”</p>
                <div className="mt-6 pt-5 border-t border-zinc-800 flex items-center gap-3">
                  <span className="w-9 h-9 bg-[#FF3B30] flex items-center justify-center font-display font-bold text-sm">
                    {r.name[0]}
                  </span>
                  <div>
                    <p className="font-display uppercase tracking-wide text-sm">{r.name}</p>
                    <p className="text-zinc-500 text-xs">{r.vehicle}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
